import React from "react";
import { TableBodyRow, TableHead } from "../../../../../widget/styledComponents/table.style";
import { Spinner } from "evergreen-ui";
import { gql, useQuery } from "@apollo/client";
import DuesModal from "../widget/add_new_dues_to_units";
import Cookies from "js-cookie";
import RemoveDuesModal from "../widget/remove_new_dues_to_units";

export const FETCH_DUES_BY_PROPERTY = gql`
  query Dues_getByProperty($propertyId: ID!) {
    dues_getByProperty(propertyId: $propertyId) {
      _id
      title
      defaultAmount
      startDate
      endDate
    }
  }
`;

function Dues(props) {
  const propertyId = props.details._id; 
  const facilityId = Cookies.get("facilityId"); 
  const { loading, error, data } = useQuery(FETCH_DUES_BY_PROPERTY, {
    variables: { propertyId },
  });

  if (loading) return <Spinner />;
  if (error)
    return (
      <div>
        <i className="material_icons">error_outline</i> Error loading dues.
      </div>
    );

  const transactions = data?.dues_getByProperty || [];
  const alreadyAddedDueIds = transactions.map((due) => due._id); // Extract already added due IDs

  return (
    <div>
      <table className="responsive-table">
        <thead>
          <tr>
            <TableHead>Title</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Start Date</TableHead>
            <TableHead>End Date</TableHead>
            <TableHead>Status</TableHead>
          </tr>
        </thead>
        <tbody>
          {transactions.map((due) => (
            <TableBodyRow key={due._id}>
              <td>{due.title}</td>
              <td>N{due.defaultAmount}</td>
              <td>{new Date(due.startDate).toLocaleDateString()}</td>
              <td>{new Date(due.endDate).toLocaleDateString()}</td>
              <td>Successful</td>
            </TableBodyRow>
          ))}
        </tbody>
      </table>
      <br/>
      <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
        <DuesModal 
          facilityId={facilityId} 
          propertyIds={[propertyId]} 
          alreadyAddedDueIds={alreadyAddedDueIds} 
        />
        <RemoveDuesModal 
          facilityId={facilityId} 
          propertyIds={[propertyId]} 
        />
      </div>
    </div>
  );
}

export default Dues;
